import { crowdinlink } from "./utils.ts"

export const PMs: Record<string, { first: string; last: string; name: string; email: string }> = {
  bzadik: { first: "Benjamin", last: "Zadik", name: "Benjamin Zadik", email: "zadik@ibabbleon.com" },
  salim: { first: "Salim", last: "Martell", name: "Salim Martell", email: "salim@ibabbleon.com" },
  Delena: { first: "Elena", last: "Drozdova", name: "Elena Drozdova", email: "elena@babblesf.com" },
}

// Resolve a developer's assignedby to a PM entry, falling back to Benjamin if
// the username isn't in the map. Emits a dev-mode warning so stale assignedby
// values surface during local testing instead of silently going to Ben.
const warnedPMKeys = new Set<string>()
export function lookupPM(assignedby: string | null | undefined) {
  if (!assignedby) return PMs.bzadik
  const hit = PMs[assignedby]
  if (hit) return hit
  if (import.meta.env.DEV && !warnedPMKeys.has(assignedby)) {
    warnedPMKeys.add(assignedby)
    console.warn(`[PMs] No entry for assignedby="${assignedby}" — falling back to Benjamin. Add them to src/compositions/strings.ts.`)
  }
  return PMs.bzadik
}

export const statusColor: Record<string, { color: string; icon: string }> = {
  Open: { color: "info", icon: "folder-open" },
  Delivered: { color: "success", icon: "truck-fast" },
  Complete: { color: "secondary", icon: "hexagon-check" },
  Done: { color: "secondary", icon: "hexagon-check" },
  Draft: { color: "contrast", icon: "file-exclamation" },
  Unsent: { color: "contrast", icon: "mailbox" },
  Accepted: { color: "warn", icon: "calendar-check" },
  "No reply": { color: "danger", icon: "bell-exclamation" },
  Finished: { color: "success", icon: "clipboard-check" },
  Invoiced: { color: "info", icon: "money-check" },
  Internal: { color: "info", icon: "folder-open" },
  Working: { color: "info", icon: "folder-open" },
  Deleted: { color: "danger", icon: "trash-alt" },
}

export const invoiceStatuses: Record<string, { color: string; icon: string }> = {
  estimate: { color: "danger", icon: "fal fa-inbox-arrow-down" },
  sent: { color: "secondary", icon: "fal fa-paper-plane" },
  viewed: { color: "contrast", icon: "fal fa-eye" },
  approved: { color: "info", icon: "fal fa-clipboard-check" },
  paid: { color: "primary", icon: "fal fa-dollar" },
  pending: { color: "warn", icon: "fal fa-question" },
}
export const BABBLEURL = import.meta.env.VITE_APP_URL

export const EMAIL_translation_done: Record<string, string> = {
  Developer:
    'Good news! Your files are all ready. You can download it from your account page:<br/><br/><a href="{{LINK}}">{{INVOICENAME}}</a><br/><br/>Let me know if you spot any issues.<br/><br/>Thank you,<br/><p>{{PM}}<br/>www.ibabbleon.com</p>',
  Crowdin:
    "Good news! Your translations are all ready in Crowdin.<br/><br/><b>{{INVOICENAME}}</b><br/>{{LINK}}<br/>Let me know if you spot any issues.<br/><br/>Thank you,<br/><p>{{PM}}</p>",
  "Academy of Art":
    'Good news! Your translation is ready. It has been sent automatically to the Academy of Art. You can also download a copy of your translation here:<br/><br/><a href="{{LINK}}">{{INVOICENAME}}</a><br/><br/>If you see any mistake, please let me know about it and I will make the changes you need.<br/><br/>Thank you,<br/>{{PM}}<br/>www.babblesf.com</p>',
  Revision: 'The revisions you requested are done. You can <a href="{{LINK}}">download it</a> from the same link as before.<br/><p>Thank you,</p><p>{{PM}}</p>',
  Notary:
    'Good news! Your translation is ready for you to approve. You can download it here:<br/><br/><a href="{{LINK}}">{{INVOICENAME}}</a><br/><br/>Once you approve, we can have it notarized. Also take a moment to confirm the mailing address where you want it sent.<br/><br/>Let me know about any changes you would like to make.<br/><br/>Thank you,<br/><p>{{PM}}</p>',
  Default:
    'Good news! Your translation is ready for you to approve. You can download it here:<br/><br/><a href="{{LINK}}">{{INVOICENAME}}</a><br/><br/>You can print out the file as many times as you need.<br/><br/>Let me know about any changes you would like to make.<br/><br/>Thank you,<br/><p>{{PM}}</p>',
}

export const EMAIL_got_your_approval = () => {
  let rand = Math.floor(Math.random() * 3) + 1
  if (rand == 1) {
    return `Got your approval. Thank you! I will get this started for you right away.\r\n\r\n{{PM}}`
  } else if (rand == 2) {
    return `Thanks! The approval came through. I will double-check everything and send this off to the translators.\r\n\r\n{{PM}}`
  } else {
    return `Got it! We should be able to get started right away.\r\n\r\n{{PM}}`
  }
}

export const EMAIL_approved_pm_email = `<h1 style="color:#50ad7e;">Approved!</h1><p><b>{{APPROVER}} has approved the invoice <span style="color:#50ad7e;">{{INVOICENAME}}</b></p><p>You can <a href="${
  import.meta.env.VITE_BASEURL
}/job/{{CUSTOMERINVOICE}}/new">get started and create the job</a>!</p><p>Send a quick <a href="{{MAIL}}">email to the client</a> to let them  know you are getting started.</p>`

export const EMAIL_approved_to_finance = `Hello Accounting Department,<br/><p>This is an invoice for localization work ordered and approved by {{APPROVER}} for:</p><p><b>{{INVOICENAME}}</b><br/>Link to invoice: <a href="{{HASH}}">{{HASH}}</a><br/>Date: {{INVDATE}}<br/><b style='color:green'>Due date: {{DUEDATE}}</b></p><p>Payment information is included on the invoice. A PDF copy is attached to this email.</p><p>Thank you,<br/><br/>{{PM}}</br/>Babble-on Translations</p>`

export const EMAIL_approved_task_to_approver = `<h1 style='color:#50ad7e;'>Approved!</h1>
  <p><b>Thanks so much! We're ready to get started now. Here's a copy of the work to be done for your records.</b></p>
  <span style='color:gray';'>Invoice:</span> <b style='color:#50ad7e'>{{INVOICENAME}}</b><br/><br/>
  <span style='color:gray';'>Requested due date:</span> {{DUEDATE}}<br/>
  <span style='color:gray';'>Company:</span> {{CLIENT}}<br/>
  <span style='color:gray';'>User:</span> {{APPROVER}}<br/>
  <span style='color:gray';'>Direct link:</span> <a href='{{HASH}}'>{{HASH}}</a><br/>
  <span style='color:gray';'>Message:</span><br/><em>{{MESSAGE}}</em><br/><br/>
  <span style='color:gray';'>Tasks:</span><br/>`

export const EMAIL_notify_translators_to_invoice = `<p>Hello {{TRANSLATOR}},</p><p><b>{{CLIENT}}: {{PROJECTNAME}}</b> is now ready to invoice.</p>
<p>Log in to <a href="${import.meta.env.VITE_BASEURL}/myinvoices/">your dashboard</a> to fill out your invoice form.</p><p>Thank you!</p>
<p>-- {{PM}} @ Babble-on</p>`

export const EMAIL_AOA_translation_done = `<p>Hello,</p><br/>This is an automated message to inform you that the translation for {{CLIENT}} is ready for download.<br/><br/>Go to: <a href=\"//www.ibabbleon.com/dashboard/aoa\">Academy of Art Translation Portal</a><br/><br/>—Elena`

export const EMAIL_vacation_notice = `<p><b>Vacation advisory from
{{EMAIL}}:</b><br/>Language:
{{LANGUAGE}}<br/>We have received a message from {{NAME}} about an upcoming vacation:</p>
<p style="color:green">{{START}} <span
style="color:black">until</span> {{END}}</p>
<p><b>Message:</b><br/>{{NOTES}}</p>`

export const EMAIL_invoice: Record<string, string> = {
  Default:
    'Hello {{NAME}},<br/><br/>Thank you for your message. I’d be happy to help you translate your document{{REF}}. Here is an invoice if you’d like to begin:<br/><br/>{{INVOICENAME}}<a href="{{LINK}}">{{LINK}}</a><br/><br/>{{TIMEESTIMATE}}{{PAYMENT}}{{PDF}}{{TRANSLITERATION}}<br/><br/>Thank you,<br/><p>{{PM}}<br/>Babble-on Translations</p>',
  "Academy of Art":
    'Hello {{NAME}},<br/><br/>We have received your documents to translate for the Academy of Art University. Please click on the following link to VIEW and PAY the translation fee:<br/><br/><a href="{{LINK}}">{{LINK}}</a><br/><br/>{{TIMEESTIMATE}}{{PAYMENT}}{{PDF}}{{TRANSLITERATION}}<br/><br/>Thank you,<br/><p>{{PM}}<br/>Babble-on Translations</p>',
  Preapproved:
    'Hello {{NAME}},<br/><br/>Thank you for your message and for pre-approving{{REF}}. I’m getting this started for you now. Here is the invoice for your records:<br/><br/>{{INVOICENAME}}<a href="{{LINK}}">{{LINK}}</a><br/><br/>{{TIMEESTIMATE}}<br/><br/>Thank you,<br/><p>{{PM}}<br/>Babble-on Translations</p>',
  Accounting:
    'Hello AP Dept,<br/><br/>This is an invoice for localization work ordered and approved by {{APPROVER}}{{REF}}. Please feel free to email me with any questions.<br/><br/><a href="{{LINK}}">{{LINK}}</a><br/>{{INVOICELIST}}<br/>Bank information is included for direct deposit in the Payment information section of the bottom of the invoice.{{PDF}}<br/><br/>Thank you,<br/><p>{{PM}}</p>',
}

export const EMAIL_notify_translator_paid = `<p>Hello {{name}},</p><p>Here is a list of recent invoices that have been paid:</p><p>{{invoices_paid}}</p><p>We issued you a total payment of <span style=color:green>{{total_paid}}</span> today. It can take <u>1–3 business days</u> to arrive in your bank.</p><p>If you have any questions, let me know.</p><p>-- Elena<br/>elena@ibabbleon.com</p>`

export const getCrowdinList = (linktofile: string, defaultlang: string) => {
  let crowdinlist = ""
  try {
    const crowdin = JSON.parse(linktofile)
    if (crowdin && crowdin.length > 0) {
      for (var i = 0; i < crowdin.length; i++) {
        let files = crowdin[i].tasks ? "tasks" : "files"
        if (crowdin[i][files]) {
          var source = crowdin[i].source || "en"
          source = source.split("||")[0]
          for (var j = 0; j < crowdin[i][files].length; j++) {
            let langcode: any
            if (crowdin[i][files][j].languages) {
              langcode = crowdin[i][files][j].languages[0].code
            } else {
              langcode = defaultlang
            }
            let link = crowdinlink(files, crowdin[i].crowdin, crowdin[i][files][j].id, source, langcode)
            let name = `${files == "files" ? crowdin[i][files][j].path : ""}${crowdin[i][files][j].name}`
            crowdinlist += `<a href="${link}">${name}</a><br/>`
          }
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  return crowdinlist
}

export const getBankInfo = (currency: string) => {
  let bankinfo
  switch (currency) {
    case "EUR":
      bankinfo =
        "Payable to account: <b>Babble-on Inc</b><br>IBAN: <b>BE60 9670 2273 7570</b><br>SWIFT/BIC: <b>TRWIBEB1XXX</b><br>Address: Wise<br>Rue du Trône 100, 3rd floor<br>Brussels<br>1050 Belgium"
      break
    case "GBP":
      bankinfo =
        "Payable to account: <b>Babble-on Inc</b><br>Account number: <b>74429212</b><br>IBAN: <b>GB41 TRWI 2314 7074 4292 12</b><br>UK Sort Code: <b>23-14-70</b><br>Address: Wise Payments Limited<br>1st Floor, Worship Square<br>65 Clifton Street, London<br>EC2A 4JE UK"
      break
    case "AUD":
      bankinfo =
        "Payable to account: <b>Babble-on Inc</b><br>Account number: <b>204310231</b><br>BSB Code: <b>774-001</b><br>SWIFT/BIC: <b>TRWIAUS1XXX</b><br>Address: Wise Australia Pty Ltd<br>Suite 1, Level 11, 66 Goulburn Street,<br>Sydney, NSW 2000<br>Australia"
      break
    case "NZD":
      bankinfo =
        "Payable to account: <b>Babble-on Inc</b><br>Account number: <b>04-2021-0072061-31</b><br>Address: Wise Payments Ltd. - New Zealand Branch<br>1st Floor, Worship Square<br>65 Clifton Street, London<br>EC2A 4JE UK"
      break
    case "HUF":
      bankinfo =
        "Payable to account: <b>Babble-on Inc</b><br>Account number: <b>12600016-14282233-12134574</b><br>Address: Wise<<br>Rue du Trône 100, 3rd floor<br>Brussels<br>1050 Belgium"
      break
    case "SGD":
      bankinfo =
        "Payable to account: <b>Babble-on Inc</b><br>Account number: <b>2147338</b><br>Bank Code: <b>0516</b><br><br>Bank name: <b>Wise Asia-Pacific Pte. Ltd.</b><br>Address: 2 Tanjong Katong Road, #07-01<br>PLQ3, Singapore, 437161"
    case "TRY":
      bankinfo = "Payable to account: <b>Babble-on Inc</b><br>IBAN: <b>TR77 0010 3000 0000 0034 4348 14</b>"
      break
    case "USD":
      bankinfo =
        "Preferred Payment Details<br><br><u>ACH transfer (direct deposit)</u><br>Payable to: <b>Babble-on</b><br>Routing number: <b>321076506</b><br>Account number: <b>75600050622010</b>"
      break

    default:
      bankinfo = ""
  }
  return bankinfo
}

export const shippingOptions = [
  { category: "Shipping", shipping: "First-class mail FREE", name_and_description: "Shipping: First-class mail FREE", price: 0 },
  { category: "Shipping", shipping: "USPS Priority Mail", name_and_description: "Shipping: USPS Priority Mail", price: 10.95 },
  { category: "Shipping", shipping: "USPS Priority Express Overnight", name_and_description: "Shipping: USPS Priority Express Overnight", price: 33 },
]

export const paymentMethodIcons: Record<string, string> = {
  "Credit Card": "fal fa-credit-card",
  ACH: "fal fa-bank",
  PayPal: "fab fa-paypal",
  Link: "fab fa-cc-stripe",
  Wise: "fal fa-w",
  "Apple Pay": "fab fa-apple-pay",
  eCheck: "fal fa-money-check-dollar",
  Alipay: "fab fa-alipay",
  Wechat_pay: "fab fa-weibo",
  "Google Pay": "fab fa-google-pay",
}

export const unitoptions = [
  "word",
  "language",
  "character",
  "day",
  "deposit",
  "description",
  "document",
  "hour",
  "item",
  "line",
  "minute",
  "month",
  "page",
  "project",
  "release",
  "signature",
  "total",
]
export const categoryoptions = [
  { key: "localization", name: "Localization", icon: "fas fa-globe", price: 0.22, unit: "word" },
  { key: "review", name: "Review", icon: "fas fa-eye", price: 0.13, unit: "word" },
  { key: "mtpe", name: "MT-Post-editing", icon: "fas fa-robot", price: 0.18, unit: "word" },
  { key: "transcreation", name: "Transcreation", icon: "fas fa-typewriter", price: 0.25, unit: "word" },
  { key: "document", name: "Document Translation", icon: "fas fa-file-word", price: 70, unit: "page" },
  { key: "translation", name: "Translation per word", icon: "fal fa-exchange-alt", price: 0.22, unit: "word" },
  { key: "notary", name: "Notary", icon: "fas fa-certificate", price: 15, unit: "signature", description: "Notary's signature" },
  { key: "description", name: "App Description", icon: "fab fa-app-store-ios", price: 99, unit: "description" },
  { key: "release", name: "Press Release", icon: "fal fa-newspaper", price: 229, unit: "release" },
  { key: "copywriting", name: "Copywriting", icon: "fas fa-pen-square", price: 100, unit: "hour" },
  { key: "editing", name: "Editing", icon: "fas fa-cut", price: 100, unit: "hour" },
  { key: "shipping", name: "Shipping", icon: "fas fa-envelope", price: 10.95, unit: "item", shipping: "USPS Priority Mail", description: "USPS Priority Mail" },
  { key: "meeting", name: "Phone Meeting", icon: "fas fa-phone", price: 50, unit: "hour" },
  { key: "bank", name: "Bank fee", icon: "fal fa-piggy-bank", price: 20, unit: "total" },
  { key: "consumables", name: "Consumables", icon: "fal fa-gift-card", price: 50, unit: "project" },
  { key: "scan", name: "Scan Copy", icon: "fal fa-scanner-image", price: 5, unit: "total", description: "Scan and email notarized copy" },
  { key: "cdn", name: "CDN", icon: "fal fa-chart-network", price: 25, unit: "month", description: "Requests: , Data transferred:" },
  { key: "hourly", name: "Hourly Work", icon: "fal fa-clock", price: 75, unit: "hour" },
  { key: "discount", name: "Discount", icon: "fas fa-dollar-sign", price: 0, unit: "total" },
  { key: "deposit", name: "Deposit", icon: "fas fa-credit-card", price: null, unit: "total" },
]
export const categoryWithLanguage = ["localization", "transcreation", "mt-post-editing", "document translation", "translation per word", "review"]

export const activityShorthand: Record<string, { icon: string; severity?: string; action?: string }> = {
  "Approved translation": { icon: "fal fa-check-square", severity: "success" },
  "Approved Invoice": { icon: "fal fa-signature", severity: "success" },
  "Restored Invoice": { icon: "fal fa-trash-undo", severity: "secondary" },
  "Updated Invoice": { icon: "fal fa-edit", action: "Invoice updated", severity: "secondary" },
  "Renamed Invoice": { icon: "fal fa-file-signature", action: "Renamed invoice", severity: "secondary" },
  "Refund payment": { icon: "fal fa-hand-holding-usd", severity: "secondary" },
  "Job created": { icon: "fal fa-folder-plus", severity: "secondary" },
  "Job updated": { icon: "fal fa-folder-grid", severity: "secondary" },
  "Moved invoice to trash": { icon: "fal fa-trash-alt", severity: "warn" },
  "Job Finished": { icon: "fal fa-flag-checkered", action: "All translators done", severity: "success" },
  "No replies": { icon: "fal fa-clipboard-user", action: "Translator hasn’t replied", severity: "error" },
  "No reply": { icon: "fal fa-comment-dots", severity: "danger" },
  Finished: { icon: "fal fa-clipboard-check", action: "Finished translation", severity: "secondary" },
  Accepted: { icon: "fal fa-handshake", action: "Accepted job", severity: "secondary" },
  Late: { icon: "fal fa-alarm-exclamation", action: "Translator is Late", severity: "warn" },
  Invoiced: { icon: "fal fa-file-invoice-dollar", action: "Created invoice", severity: "info" },
  "Invoiced us": { icon: "fal fa-money-check-alt", severity: "info" },
  "Draft request": { icon: "fal fa-file-edit", severity: "secondary" },
  "Updated files": { icon: "fal fa-file-import", severity: "secondary" },
  "Updated notes": { icon: "fal fa-file-edit", severity: "secondary" },
  "Viewed invoice": { icon: "fal fa-eye", severity: "secondary" },
  Paid: { icon: "fal fa-credit-card", action: "Client paid invoice", severity: "success" },
  Screenshots: { icon: "fal fa-image", action: "Project screenshots uploaded", severity: "secondary" },
  "QA Screenshots": { icon: "fal fa-print-search", action: "QA screenshots uploaded", severity: "secondary" },
  Complete: { icon: "fal fa-globe", action: "Completed in Crowdin", severity: "secondary" },
  "Notification sent": { icon: "fal fa-mail-bulk", action: "Notification sent to translators", severity: "secondary" },
  "Uploaded file": { icon: "fal fa-upload", action: "Translator uploaded file", severity: "secondary" },
  Downloaded: { icon: "fal fa-download", action: "Downloaded project", severity: "secondary" },
  Approved: { icon: "fal fa-thumbs-up", action: "Approved project", severity: "success" },
  "Email sent": { icon: "fal fa-paper-plane", action: "Email resent", severity: "secondary" },
  "Email resent": { icon: "fal fa-paper-plane", action: "Email sent to client", severity: "secondary" },
  Delivered: { icon: "fal fa-truck", action: "Delivered to client", severity: "secondary" },
  Closed: { icon: "fal fa-archive", action: "Job complete", severity: "secondary" },
  Open: { icon: "fal fa-refresh", action: "Re-opened job", severity: "secondary" },
  Viewed: { icon: "fal fa-eye", severity: "secondary" },
  Registered: { icon: "fal fa-user-plus", severity: "secondary" },
  "Request received": { icon: "fal fa-inbox-in", severity: "secondary" },
  "Request Updated": { icon: "fal fa-inbox-in", severity: "secondary" },
  "Copywriting request": { icon: "fal fa-inbox-in", severity: "secondary" },
  "Sent to Accounting": { icon: "fal fa-comment-dollar", severity: "secondary" },
}

type ColorPalette = { main: string; container: string; onContainer: string }
type ColorTheme = { colorName: string; lightColors: ColorPalette; darkColors: ColorPalette }
export const colorThemes: Record<string, ColorTheme> = {
  personal: {
    colorName: "personal",
    lightColors: {
      main: "#f9d71c",
      container: "#fff5aa",
      onContainer: "#594800",
    },
    darkColors: {
      main: "#fff5c0",
      onContainer: "#fff5de",
      container: "#a29742",
    },
  },
  work: {
    colorName: "work",
    lightColors: {
      main: "#f91c45",
      container: "#ffd2dc",
      onContainer: "#59000d",
    },
    darkColors: {
      main: "#ffc0cc",
      onContainer: "#ffdee6",
      container: "#a24258",
    },
  },
  leisure: {
    colorName: "leisure",
    lightColors: {
      main: "#1cf9b0",
      container: "#dafff0",
      onContainer: "#004d3d",
    },
    darkColors: {
      main: "#c0fff5",
      onContainer: "#e6fff5",
      container: "#42a297",
    },
  },
  school: {
    colorName: "school",
    lightColors: {
      main: "#1c7df9",
      container: "#d2e7ff",
      onContainer: "#002859",
    },
    darkColors: {
      main: "#c0dfff",
      onContainer: "#dee6ff",
      container: "#426aa2",
    },
  },
  adventure: {
    colorName: "adventure",
    lightColors: { main: "#ff9800", container: "#ffe0b2", onContainer: "#663c00" },
    darkColors: { main: "#ffcc80", container: "#a25f00", onContainer: "#fff3e0" },
  },
  fitness: {
    colorName: "fitness",
    lightColors: { main: "#4caf50", container: "#c8e6c9", onContainer: "#1b5e20" },
    darkColors: { main: "#a5d6a7", container: "#388e3c", onContainer: "#e8f5e9" },
  },
  travel: {
    colorName: "travel",
    lightColors: { main: "#03a9f4", container: "#b3e5fc", onContainer: "#01579b" },
    darkColors: { main: "#81d4fa", container: "#0288d1", onContainer: "#e1f5fe" },
  },
  chill: {
    colorName: "chill",
    lightColors: { main: "#e91e63", container: "#f8bbd0", onContainer: "#880e4f" },
    darkColors: { main: "#f48fb1", container: "#ad1457", onContainer: "#fce4ec" },
  },
  errands: {
    colorName: "errands",
    lightColors: { main: "#9c27b0", container: "#e1bee7", onContainer: "#4a0072" },
    darkColors: { main: "#ce93d8", container: "#7b1fa2", onContainer: "#f3e5f5" },
  },
  birthday: {
    colorName: "birthday",
    lightColors: { main: "#ff5722", container: "#ffccbc", onContainer: "#bf360c" },
    darkColors: { main: "#ffab91", container: "#d84315", onContainer: "#fbe9e7" },
  },
  anniversary: {
    colorName: "anniversary",
    lightColors: { main: "#c2185b", container: "#f8bbd0", onContainer: "#880e4f" },
    darkColors: { main: "#f06292", container: "#ad1457", onContainer: "#fce4ec" },
  },
  meditation: {
    colorName: "meditation",
    lightColors: { main: "#3f51b5", container: "#c5cae9", onContainer: "#1a237e" },
    darkColors: { main: "#9fa8da", container: "#303f9f", onContainer: "#e8eaf6" },
  },
  cooking: {
    colorName: "cooking",
    lightColors: { main: "#ff7043", container: "#ffe0b2", onContainer: "#e65100" },
    darkColors: { main: "#ffab91", container: "#f57c00", onContainer: "#fff3e0" },
  },
  garden: {
    colorName: "garden",
    lightColors: { main: "#8bc34a", container: "#dcedc8", onContainer: "#33691e" },
    darkColors: { main: "#aed581", container: "#689f38", onContainer: "#f1f8e9" },
  },
  tech: {
    colorName: "tech",
    lightColors: { main: "#00bcd4", container: "#b2ebf2", onContainer: "#006064" },
    darkColors: { main: "#4dd0e1", container: "#0097a7", onContainer: "#e0f7fa" },
  },
  finance: {
    colorName: "finance",
    lightColors: { main: "#607d8b", container: "#cfd8dc", onContainer: "#263238" },
    darkColors: { main: "#90a4ae", container: "#455a64", onContainer: "#eceff1" },
  },
  health: {
    colorName: "health",
    lightColors: { main: "#43a047", container: "#c8e6c9", onContainer: "#1b5e20" },
    darkColors: { main: "#66bb6a", container: "#2e7d32", onContainer: "#e8f5e9" },
  },
  art: {
    colorName: "art",
    lightColors: { main: "#e040fb", container: "#f3e5f5", onContainer: "#6a1b9a" },
    darkColors: { main: "#ba68c8", container: "#8e24aa", onContainer: "#f3e5f5" },
  },
  music: {
    colorName: "music",
    lightColors: { main: "#7e57c2", container: "#d1c4e9", onContainer: "#4a148c" },
    darkColors: { main: "#9575cd", container: "#512da8", onContainer: "#ede7f6" },
  },
  party: {
    colorName: "party",
    lightColors: { main: "#ec407a", container: "#f8bbd0", onContainer: "#880e4f" },
    darkColors: { main: "#f48fb1", container: "#c2185b", onContainer: "#fce4ec" },
  },
  cleanup: {
    colorName: "cleanup",
    lightColors: { main: "#26a69a", container: "#b2dfdb", onContainer: "#004d40" },
    darkColors: { main: "#80cbc4", container: "#00796b", onContainer: "#e0f2f1" },
  },
  pets: {
    colorName: "pets",
    lightColors: { main: "#fbc02d", container: "#fff9c4", onContainer: "#f57f17" },
    darkColors: { main: "#fff176", container: "#fbc02d", onContainer: "#fffde7" },
  },
  volunteer: {
    colorName: "volunteer",
    lightColors: { main: "#ab47bc", container: "#e1bee7", onContainer: "#6a1b9a" },
    darkColors: { main: "#ce93d8", container: "#8e24aa", onContainer: "#f3e5f5" },
  },
}

export const shareholderCategories = ["Retirement Contribution", "Distribution", "Loan Repayment", "Taxes", "Salary and Bonus", "NET Wages", "Transfer", "Business Credit Card"]

export const expenseCategories = [
  { label: "Accounting Fees", value: "Accounting" },
  { label: "Advertising", value: "Advertising" },
  { label: "Bad Debt", value: "Bad Debt" },
  { label: "Bank charges", value: "Bank charges" },
  { label: "Business Credit Card", value: "Business Credit Card" },
  { label: "Travel", value: "Business Travel" },
  { label: "Charitable", value: "Charitable" },
  { label: "Collections", value: "Collections" },
  { label: "Commissions", value: "Commissions" },
  { label: "Computers", value: "Computers" },
  { label: "Shareholder Distribution", value: "Distribution" },
  { label: "Dues and Subscriptions", value: "Dues and Subscriptions" },
  { label: "Independent Contractor", value: "Ind. Contractor" },
  { label: "Insurance Medical", value: "Insurance Medical" },
  { label: "Insurance (not medical)", value: "Insurance not medical" },
  { label: "Interest", value: "Interest" },
  { label: "Legal/Professional Fees", value: "Legal Professional Fees" },
  { label: "Life insurance", value: "Life insurance" },
  { label: "Loan Repayment", value: "Loan Repayment" },
  { label: "Meals and Entertainment", value: "Meals and Entertainment" },
  { label: "NET Wages", value: "NET Wages" },
  { label: "Office Expenses", value: "Office Expenses" },
  { label: "Organizational", value: "Organizational" },
  { label: "Postage", value: "Postage" },
  { label: "Refunds", value: "Refunds" },
  { label: "Rent", value: "Rent" },
  { label: "Repairs", value: "Repairs" },
  { label: "Retirement Contribution", value: "Retirement Contribution" },
  { label: "Salary and Bonus", value: "Salary and Bonus" },
  { label: "Supplies", value: "Supplies" },
  { label: "Taxes", value: "Taxes" },
  { label: "Telephone", value: "Telephone" },
  { label: "Tools", value: "Tools" },
  { label: "Training", value: "Training" },
  { label: "Transfer", value: "Transfer" },
  { label: "Utilities", value: "Utilities" },
  { label: "Vehicle", value: "Vehicle" },
]

export const expensePaymentMethods = [
  { label: "Chase Ink", value: "ChaseInk" },
  { label: "Check", value: "Check" },
  { label: "SF Fire", value: "Withdraw HSBC" },
  { label: "PayPal", value: "PayPal" },
  { label: "Stripe", value: "Stripe" },
  { label: "Chase Sapphire", value: "Chase Sapphire" },
  { label: "Cash", value: "Cash" },
  { label: "First Republic", value: "First Republic" },
  { label: "Direct Deposit (ACH)", value: "Direct Deposit (ACH)" },
  { label: "Other", value: "" },
]

type MatchContext = {
  details: string
  debit: number
}

type Rule = {
  test: (ctx: MatchContext) => boolean
  result: {
    payTo: string
    description: string
    category: string
    method: string
    icon?: string
  }
}

export const expenseRules: Rule[] = [
  {
    test: ({ details, debit }) => /transfer.*capital/i.test(details) && (debit === -10000 || debit === -5000),

    result: {
      payTo: "Benjamin Zadik",
      description: "Shareholder Distribution",
      category: "Distribution",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details, debit }) => /capital one/i.test(details) && debit === -750,

    result: {
      payTo: "Benjamin Zadik",
      description: "Rent for office - " + new Date().toLocaleString("en-US", { month: "long", year: "numeric" }),
      category: "Rent",
      method: "Direct Deposit (ACH)",
      icon: "fal fa-building",
    },
  },

  {
    test: ({ details }) => /comfy/i.test(details),

    result: {
      payTo: "Runcomfy.com",
      description: "AI subscription",
      category: "Computers",
      method: "Withdraw HSBC",
      icon: "fal fa-magic-wand-sparkles",
    },
  },

  {
    test: ({ details }) => /state\scomp/i.test(details),

    result: {
      payTo: "State Comp Ins Fund",
      description: "Workmans Compensation",
      category: "Insurance not medical",
      method: "Withdraw HSBC",
      icon: "fal fa-person-falling",
    },
  },

  {
    test: ({ details }) => /BUSINESS TAX/i.test(details),

    result: {
      payTo: "SF County Treasurer",
      description: "SF Business Registration",
      category: "Taxes",
      method: "Withdraw HSBC",
      icon: "fal fa-sack-dollar",
    },
  },

  {
    test: ({ details }) => /connectyourcare/i.test(details),

    result: {
      payTo: "Optum Financial HSA",
      description: "Health Savings Contribution for Benjamin Zadik",
      category: "Insurance Medical",
      method: "Withdraw HSBC",
      icon: "fal fa-prescription",
    },
  },

  {
    test: ({ details }) => /vanguard/i.test(details),

    result: {
      payTo: "Vanguard",
      description: "SEP Employer Contribution for Benjamin Zadik",
      category: "Retirement Contribution",
      method: "Withdraw HSBC",
      icon: "fal fa-ship",
    },
  },

  {
    test: ({ details }) => /usataxpymt/i.test(details),

    result: {
      payTo: "IRS",
      description: "Federal Taxes (941/944)",
      category: "Taxes",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details }) => /gusto:\s*tax/i.test(details),

    result: {
      payTo: "CA PIT / SDI",
      description: "Payroll Taxes",
      category: "Taxes",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details }) => /franchise/i.test(details),

    result: {
      payTo: "Franchise Tax Board",
      description: "California Taxes",
      category: "Taxes",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details }) => /gusto:\s*net/i.test(details),

    result: {
      payTo: "Benjamin Zadik and Olena Drozdova",
      description: "NET Salaries",
      category: "NET Wages",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details }) => /gusto:\s*fee/i.test(details),

    result: {
      payTo: "Wray Rives CPA Gusto",
      description: "Payroll Accounting",
      category: "Accounting",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details, debit }) => /babble-on inc/i.test(details) && debit < -5000,

    result: {
      payTo: "Benjamin Zadik",
      description: "Shareholder Distribution",
      category: "Distribution",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details }) => /chase/i.test(details),

    result: {
      payTo: "Chase",
      description: "Chase Ink Business Credit Card",
      category: "Business Credit Card",
      method: "Withdraw HSBC",
    },
  },

  {
    test: ({ details }) => /instamed/i.test(details),

    result: {
      payTo: "Payflex",
      description: "Medical Insurance Employees",
      category: "Insurance Medical",
      method: "Withdraw HSBC",
      icon: "fal fa-prescription",
    },
  },

  {
    test: ({ details }) => /fed wire|charge fee|wire/i.test(details),

    result: {
      payTo: "SF Fire Credit Union",
      description: "Wire transfer charges",
      category: "Bank charges",
      method: "Withdraw HSBC",
    },
  },
]

export const calendarAllowedLocales = [
  "ca-ES",
  "zh-CN",
  "zh-TW",
  "hr-HR",
  "cs-CZ",
  "da-DK",
  "nl-NL",
  "en-GB",
  "en-US",
  "et-EE",
  "fi-FI",
  "fr-FR",
  "de-DE",
  "he-IL",
  "id-ID",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "ky-KG",
  "lt-LT",
  "mk-MK",
  "pl-PL",
  "pt-BR",
  "ro-RO",
  "ru-RU",
  "sr-Latn-RS",
  "sr-RS",
  "sk-SK",
  "sl-SI",
  "es-ES",
  "sv-SE",
  "tr-TR",
  "uk-UA",
]

// Rotating welcome text
export const welcomeTexts = [
  "Welcome",
  "Bienvenido",
  "歡迎光臨",
  "Добро пожаловать",
  "Welkom",
  "Bienvenue",
  "ようこそ",
  "Bem-vindo",
  "ยินดีต้อนรับ",
  "Tervetuloa",
  "환영합니다",
  "ברוך הבא",
  "Willkommen",
  "Benvenuto",
  "Ongi etorri",
  "Velkommen",
  "أهلا وسهلا",
  "Selamat datang",
  "Bine ai venit",
  "Vitaj",
  "Ласкаво просимо",
  "Hoan nghênh",
]

export const countrylist = [
  "USA",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic of The",
  "Cook Islands",
  "Costa Rica",
  "Cote D'ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-bissau",
  "Guyana",
  "Haiti",
  "Heard Island and Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic of",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and The Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and The South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Republic of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
]

// For AOA:

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burma",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "CAR",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (drc)",
  "Congo (RC)",
  "Costa Rica",
  "Cote dIvoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech",
  "Denmark",
  "Djibouti",
  "Dominican",
  "Dominica",
  "East Timor",
  "Ecuador",
  "Egypt",
  "Elsalvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Greenland",
  "Grenada",
  "Guatemala",
  "Guinea Bissau",
  "Guinea",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Korea North",
  "Korea South",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Mongolia",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nepal",
  "Netherland",
  "New zealand",
  "Nicaragua",
  "Nigeria",
  "Niger",
  "Norway",
  "Oman",
  "Pakistan",
  "Panama",
  "Papua Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somali",
  "South Africa",
  "Spain",
  "Sri lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Trinidad",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "U A E",
  "Ugandan",
  "Ukraine",
  "United kingdom",
  "Uruguay",
  "United States",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
]

export const countryLanguages = [
  "Dari Persian, Pashto",
  "Albanian",
  "Arabic",
  "Catalan",
  "Portuguese",
  "English",
  "Spanish",
  "Armenian",
  "English",
  "German",
  "Azerbaijani",
  "English",
  "Arabic",
  "Bengali",
  "English",
  "Belarusian, Russian",
  "Dutch, French, German",
  "English",
  "French",
  "English",
  "Dzongkha",
  "Spanish, Quechua, Aymara",
  "Bosnian, Croatian and Serbian",
  "English",
  "Portuguese",
  "Malay",
  "Bulgarian",
  "French",
  "Burmese",
  "Kirundi, French",
  "Khmer",
  "English",
  "English",
  "Sango, French",
  "French, Arabic",
  "Spanish",
  "Chinese",
  "Spanish",
  "Comorian, Arabic, French",
  "French",
  "French",
  "Spanish",
  "French",
  "Croatian",
  "Spanish",
  "Greek, Turkish",
  "Czech",
  "Danish",
  "Arabic, French",
  "Spanish",
  "English",
  "Portuguese",
  "Spanish",
  "Arabic",
  "Spanish",
  "Spanish, French, Portuguese",
  "None but Tigrinya, Arabic and English",
  "Estonian",
  "Amharic",
  "English",
  "Finnish, Swedish",
  "French",
  "French",
  "English",
  "Georgian",
  "German",
  "English",
  "Greek",
  "Greenlandic, Danish",
  "English",
  "Spanish",
  "Portuguese",
  "French",
  "English",
  "French, Haitian Creole",
  "Spanish",
  "Hungarian",
  "Icelandic",
  "Hindi, English",
  "Indonesian",
  "Farsi",
  "Arabic, Kurdish, Aramaic",
  "English",
  "Hebrew",
  "Italian",
  "English",
  "Japanese",
  "Arabic",
  "Kazakh, Russian",
  "English",
  "Korean",
  "Korean",
  "Arabic",
  "Kyrgyz, Russian",
  "Lao",
  "Latvian",
  "Arabic",
  "English",
  "English",
  "Arabic",
  "German",
  "Lithuanian",
  "French, German, Luxembourgish",
  "Macedonian",
  "Malagasy, French, English",
  "English, Chichewa",
  "Malay",
  "Dhivehi",
  "French",
  "Arabic",
  "English",
  "Spanish",
  "Moldovan",
  "Mongolian",
  "Arabic",
  "Portuguese",
  "English",
  "Nepali",
  "Dutch",
  "English",
  "Spanish",
  "English",
  "French",
  "Norwegian",
  "Arabic",
  "Urdu",
  "Spanish",
  "English, Tok Pisin, Hiri Motu",
  "Spanish, Guarani",
  "Spanish",
  "Filipino, English",
  "Polish",
  "Portuguese",
  "Spanish",
  "Arabic",
  "Romanian",
  "Russian",
  "Kinyarwanda, French, English",
  "Samoan, English",
  "Italian",
  "Arabic",
  "French",
  "Serbian",
  "English, French, Seychellois Creole",
  "Slovak",
  "Slovene",
  "English",
  "Somali",
  "Afrikaans, English, Southern Ndebele, Northern Sotho, Sotho, Swati, Tsonga, Tswana, Venda, Xhosa, Zulu",
  "Spanish",
  "Sinhala, Tamil",
  "Arabic",
  "Dutch",
  "English, Swati",
  "Swedish",
  "German, French, Italian, Romansh",
  "Arabic",
  "Chinese",
  "Swahili",
  "Thai",
  "French",
  "English",
  "Arabic",
  "Turkish",
  "Turkmen",
  "Arabic",
  "English, Swahili",
  "Ukrainian, Russian",
  "English",
  "Spanish",
  "English",
  "Uzbek",
  "English",
  "Spanish",
  "Vietnamese",
  "Arabic",
  "English",
  "English",
]

export const countryCodesLanguages = [
  {
    country: "Afghanistan",
    languages: ["Dari Persian", "Pashto"],
    code: "af",
  },
  {
    country: "Albania",
    languages: ["Albanian"],
    code: "al",
  },
  {
    country: "Algeria",
    languages: ["Arabic"],
    code: "dz",
  },
  {
    country: "Andorra",
    languages: ["Catalan"],
    code: "ad",
  },
  {
    country: "Angola",
    languages: ["Portuguese"],
    code: "ao",
  },
  {
    country: "Antigua",
    languages: ["English"],
    code: "ag",
  },
  {
    country: "Argentina",
    languages: ["Spanish"],
    code: "ar",
  },
  {
    country: "Armenia",
    languages: ["Armenian"],
    code: "am",
  },
  {
    country: "Australia",
    languages: ["English"],
    code: "au",
  },
  {
    country: "Austria",
    languages: ["German"],
    code: "at",
  },
  {
    country: "Azerbaijan",
    languages: ["Azerbaijani"],
    code: "az",
  },
  {
    country: "Bahamas",
    languages: ["English"],
    code: "bs",
  },
  {
    country: "Bahrain",
    languages: ["Arabic"],
    code: "bh",
  },
  {
    country: "Bangladesh",
    languages: ["Bengali"],
    code: "bd",
  },
  {
    country: "Barbados",
    languages: ["English"],
    code: "bb",
  },
  {
    country: "Belarus",
    languages: ["Belarusian", "Russian"],
    code: "by",
  },
  {
    country: "Belgium",
    languages: ["Dutch", "French", "German"],
    code: "be",
  },
  {
    country: "Belize",
    languages: ["English"],
    code: "bz",
  },
  {
    country: "Benin",
    languages: ["French"],
    code: "bj",
  },
  {
    country: "Bermuda",
    languages: ["English"],
    code: "bm",
  },
  {
    country: "Bhutan",
    languages: ["Dzongkha"],
    code: "bt",
  },
  {
    country: "Bolivia",
    languages: ["Spanish", "Quechua", "Aymara"],
    code: "bo",
  },
  {
    country: "Bosnia",
    languages: ["Bosnian", "Croatian and Serbian"],
    code: "ba",
  },
  {
    country: "Botswana",
    languages: ["English"],
    code: "bw",
  },
  {
    country: "Brazil",
    languages: ["Portuguese"],
    code: "br",
  },
  {
    country: "Brunei",
    languages: ["Malay"],
    code: "bn",
  },
  {
    country: "Bulgaria",
    languages: ["Bulgarian"],
    code: "bg",
  },
  {
    country: "Burkina Faso",
    languages: ["French"],
    code: "bf",
  },
  {
    country: "Burundi",
    languages: ["Kirundi", "French"],
    code: "bi",
  },
  {
    country: "Cambodia",
    languages: ["Khmer"],
    code: "kh",
  },
  {
    country: "Cameroon",
    languages: ["English"],
    code: "cm",
  },
  {
    country: "Canada",
    languages: ["English"],
    code: "ca",
  },
  {
    country: "Central African Republic",
    languages: ["Sango", "French"],
    code: "cf",
  },
  {
    country: "Chad",
    languages: ["French", "Arabic"],
    code: "td",
  },
  {
    country: "Chile",
    languages: ["Spanish"],
    code: "cl",
  },
  {
    country: "China",
    languages: ["Chinese"],
    code: "cn",
  },
  {
    country: "Colombia",
    languages: ["Spanish"],
    code: "co",
  },
  {
    country: "Comoros",
    languages: ["Comorian", "Arabic", "French"],
    code: "km",
  },
  {
    country: "Congo (drc)",
    languages: ["French"],
    code: "cd",
  },
  {
    country: "Congo (RC)",
    languages: ["French"],
    code: "cg",
  },
  {
    country: "Costa Rica",
    languages: ["Spanish"],
    code: "cr",
  },
  {
    country: "Cote D'ivoire",
    languages: ["French"],
    code: "ci",
  },
  {
    country: "Croatia",
    languages: ["Croatian"],
    code: "hr",
  },
  {
    country: "Cuba",
    languages: ["Spanish"],
    code: "cu",
  },
  {
    country: "Cyprus",
    languages: ["Greek", "Turkish"],
    code: "cy",
  },
  {
    country: "Czech",
    languages: ["Czech"],
    code: "cz",
  },
  {
    country: "Denmark",
    languages: ["Danish"],
    code: "dk",
  },
  {
    country: "Djibouti",
    languages: ["Arabic", "French"],
    code: "dj",
  },
  {
    country: "Dominican Republic",
    languages: ["Spanish"],
    code: "do",
  },
  {
    country: "Dominica",
    languages: ["English"],
    code: "dm",
  },
  {
    country: "Timor-Leste",
    languages: ["Portuguese"],
    code: "tl",
  },
  {
    country: "Ecuador",
    languages: ["Spanish"],
    code: "ec",
  },
  {
    country: "Egypt",
    languages: ["Arabic"],
    code: "eg",
  },
  {
    country: "El Salvador",
    languages: ["Spanish"],
    code: "sv",
  },
  {
    country: "Equatorial Guinea",
    languages: ["Spanish", "French", "Portuguese"],
    code: "gq",
  },
  {
    country: "Eritrea",
    languages: ["None but Tigrinya", "Arabic and English"],
    code: "er",
  },
  {
    country: "Estonia",
    languages: ["Estonian"],
    code: "ee",
  },
  {
    country: "Ethiopia",
    languages: ["Amharic"],
    code: "et",
  },
  {
    country: "Fiji",
    languages: ["English"],
    code: "fj",
  },
  {
    country: "Finland",
    languages: ["Finnish", "Swedish"],
    code: "fi",
  },
  {
    country: "France",
    languages: ["French"],
    code: "fr",
  },
  {
    country: "Gabon",
    languages: ["French"],
    code: "ga",
  },
  {
    country: "Gambia",
    languages: ["English"],
    code: "gm",
  },
  {
    country: "Georgia",
    languages: ["Georgian"],
    code: "ge",
  },
  {
    country: "Germany",
    languages: ["German"],
    code: "de",
  },
  {
    country: "Ghana",
    languages: ["English"],
    code: "gh",
  },
  {
    country: "Greece",
    languages: ["Greek"],
    code: "gr",
  },
  {
    country: "Greenland",
    languages: ["Greenlandic", "Danish"],
    code: "gl",
  },
  {
    country: "Grenada",
    languages: ["English"],
    code: "gd",
  },
  {
    country: "Guatemala",
    languages: ["Spanish"],
    code: "gt",
  },
  {
    country: "Guinea Bissau",
    languages: ["Portuguese"],
    code: "gw",
  },
  {
    country: "Guinea",
    languages: ["French"],
    code: "gn",
  },
  {
    country: "Guyana",
    languages: ["English"],
    code: "gy",
  },
  {
    country: "Haiti",
    languages: ["French", "Haitian Creole"],
    code: "ht",
  },
  {
    country: "Honduras",
    languages: ["Spanish"],
    code: "hn",
  },
  {
    country: "Hungary",
    languages: ["Hungarian"],
    code: "hu",
  },
  {
    country: "Iceland",
    languages: ["Icelandic"],
    code: "is",
  },
  {
    country: "India",
    languages: ["Hindi", "English"],
    code: "in",
  },
  {
    country: "Indonesia",
    languages: ["Indonesian"],
    code: "id",
  },
  {
    country: "Iran",
    languages: ["Farsi"],
    code: "ir",
  },
  {
    country: "Iraq",
    languages: ["Arabic", "Kurdish", "Aramaic"],
    code: "iq",
  },
  {
    country: "Ireland",
    languages: ["English"],
    code: "ie",
  },
  {
    country: "Israel",
    languages: ["Hebrew"],
    code: "il",
  },
  {
    country: "Italy",
    languages: ["Italian"],
    code: "it",
  },
  {
    country: "Jamaica",
    languages: ["English"],
    code: "jm",
  },
  {
    country: "Japan",
    languages: ["Japanese"],
    code: "jp",
  },
  {
    country: "Jordan",
    languages: ["Arabic"],
    code: "jo",
  },
  {
    country: "Kazakhstan",
    languages: ["Kazakh", "Russian"],
    code: "kz",
  },
  {
    country: "Kenya",
    languages: ["English"],
    code: "ke",
  },
  {
    country: "Korea South",
    languages: ["Korean"],
    code: "kr",
  },
  {
    country: "Korea North",
    languages: ["Korean"],
    code: "kp",
  },
  {
    country: "Kuwait",
    languages: ["Arabic"],
    code: "kw",
  },
  {
    country: "Kyrgyzstan",
    languages: ["Kyrgyz", "Russian"],
    code: "kg",
  },
  {
    country: "Laos",
    languages: ["Lao"],
    code: "la",
  },
  {
    country: "Latvia",
    languages: ["Latvian"],
    code: "lv",
  },
  {
    country: "Lebanon",
    languages: ["Arabic"],
    code: "lb",
  },
  {
    country: "Lesotho",
    languages: ["English"],
    code: "ls",
  },
  {
    country: "Liberia",
    languages: ["English"],
    code: "lr",
  },
  {
    country: "Libya",
    languages: ["Arabic"],
    code: "ly",
  },
  {
    country: "Liechtenstein",
    languages: ["German"],
    code: "li",
  },
  {
    country: "Lithuania",
    languages: ["Lithuanian"],
    code: "lt",
  },
  {
    country: "Luxembourg",
    languages: ["French", "German", "Luxembourgish"],
    code: "lu",
  },
  {
    country: "Macedonia",
    languages: ["Macedonian"],
    code: "mk",
  },
  {
    country: "Madagascar",
    languages: ["Malagasy", "French", "English"],
    code: "mg",
  },
  {
    country: "Malawi",
    languages: ["English", "Chichewa"],
    code: "mw",
  },
  {
    country: "Malaysia",
    languages: ["Malay"],
    code: "my",
  },
  {
    country: "Maldives",
    languages: ["Dhivehi"],
    code: "mv",
  },
  {
    country: "Mali",
    languages: ["French"],
    code: "ml",
  },
  {
    country: "Mauritania",
    languages: ["Arabic"],
    code: "mr",
  },
  {
    country: "Mauritius",
    languages: ["English"],
    code: "mu",
  },
  {
    country: "Mexico",
    languages: ["Spanish"],
    code: "mx",
  },
  {
    country: "Moldova",
    languages: ["Moldovan"],
    code: "md",
  },
  {
    country: "Mongolia",
    languages: ["Mongolian"],
    code: "mn",
  },
  {
    country: "Morocco",
    languages: ["Arabic"],
    code: "ma",
  },
  {
    country: "Mozambique",
    languages: ["Portuguese"],
    code: "mz",
  },
  {
    country: "Myanmar (Burma)",
    languages: ["Burmese"],
    code: "mm",
  },
  {
    country: "Namibia",
    languages: ["English"],
    code: "na",
  },
  {
    country: "Nepal",
    languages: ["Nepali"],
    code: "np",
  },
  {
    country: "Netherland",
    languages: ["Dutch"],
    code: "nl",
  },
  {
    country: "New zealand",
    languages: ["English"],
    code: "nz",
  },
  {
    country: "Nicaragua",
    languages: ["Spanish"],
    code: "ni",
  },
  {
    country: "Nigeria",
    languages: ["English"],
    code: "ng",
  },
  {
    country: "Niger",
    languages: ["French"],
    code: "ne",
  },
  {
    country: "Norway",
    languages: ["Norwegian"],
    code: "no",
  },
  {
    country: "Oman",
    languages: ["Arabic"],
    code: "om",
  },
  {
    country: "Pakistan",
    languages: ["Urdu"],
    code: "pk",
  },
  {
    country: "Panama",
    languages: ["Spanish"],
    code: "pa",
  },
  {
    country: "Papua Guinea",
    languages: ["English", "Tok Pisin", "Hiri Motu"],
    code: "pg",
  },
  {
    country: "Paraguay",
    languages: ["Spanish", "Guarani"],
    code: "py",
  },
  {
    country: "Peru",
    languages: ["Spanish"],
    code: "pe",
  },
  {
    country: "Philippines",
    languages: ["Filipino", "English"],
    code: "ph",
  },
  {
    country: "Poland",
    languages: ["Polish"],
    code: "pl",
  },
  {
    country: "Portugal",
    languages: ["Portuguese"],
    code: "pt",
  },
  {
    country: "Puerto Rico",
    languages: ["Spanish"],
    code: "pr",
  },
  {
    country: "Qatar",
    languages: ["Arabic"],
    code: "qa",
  },
  {
    country: "Romania",
    languages: ["Romanian"],
    code: "ro",
  },
  {
    country: "Russia",
    languages: ["Russian"],
    code: "ru",
  },
  {
    country: "Rwanda",
    languages: ["Kinyarwanda", "French", "English"],
    code: "rw",
  },
  {
    country: "Samoa",
    languages: ["Samoan", "English"],
    code: "ws",
  },
  {
    country: "San Marino",
    languages: ["Italian"],
    code: "sm",
  },
  {
    country: "Saudi Arabia",
    languages: ["Arabic"],
    code: "sa",
  },
  {
    country: "Senegal",
    languages: ["French"],
    code: "sn",
  },
  {
    country: "Serbia",
    languages: ["Serbian"],
    code: "rs",
  },
  {
    country: "Seychelles",
    languages: ["English", "French", "Seychellois Creole"],
    code: "sc",
  },
  {
    country: "Slovakia",
    languages: ["Slovak"],
    code: "sk",
  },
  {
    country: "Slovenia",
    languages: ["Slovene"],
    code: "si",
  },
  {
    country: "Solomon Islands",
    languages: ["English"],
    code: "sb",
  },
  {
    country: "Somali",
    languages: ["Somali"],
    code: "so",
  },
  {
    country: "South Africa",
    languages: ["Afrikaans"],
    code: "za",
  },
  {
    country: "Spain",
    languages: ["Spanish"],
    code: "es",
  },
  {
    country: "Sri lanka",
    languages: ["Sinhala", "Tamil"],
    code: "lk",
  },
  {
    country: "Sudan",
    languages: ["Arabic"],
    code: "sd",
  },
  {
    country: "Suriname",
    languages: ["Dutch"],
    code: "sr",
  },
  {
    country: "Sweden",
    languages: ["Swedish"],
    code: "se",
  },
  {
    country: "Switzerland",
    languages: ["German", "French", "Italian"],
    code: "ch",
  },
  {
    country: "Syria",
    languages: ["Arabic"],
    code: "sy",
  },
  {
    country: "Taiwan",
    languages: ["Chinese"],
    code: "tw",
  },
  {
    country: "Tanzania",
    languages: ["Swahili"],
    code: "tz",
  },
  {
    country: "Thailand",
    languages: ["Thai"],
    code: "th",
  },
  {
    country: "Togo",
    languages: ["French"],
    code: "tg",
  },
  {
    country: "Trinidad and Tobago",
    languages: ["English"],
    code: "tt",
  },
  {
    country: "Tunisia",
    languages: ["Arabic"],
    code: "tn",
  },
  {
    country: "Turkey",
    languages: ["Turkish"],
    code: "tr",
  },
  {
    country: "Turkmenistan",
    languages: ["Turkmen"],
    code: "tm",
  },
  {
    country: "UAE",
    languages: ["Arabic"],
    code: "ae",
  },
  {
    country: "Uganda",
    languages: ["English", "Swahili"],
    code: "ug",
  },
  {
    country: "Ukraine",
    languages: ["Ukrainian", "Russian"],
    code: "ua",
  },
  {
    country: "United kingdom",
    languages: ["English"],
    code: "gb",
  },
  {
    country: "Uruguay",
    languages: ["Spanish"],
    code: "uy",
  },
  {
    country: "United States",
    languages: ["English"],
    code: "us",
  },
  {
    country: "Uzbekistan",
    languages: ["Uzbek"],
    code: "uz",
  },
  {
    country: "Vanuatu",
    languages: ["English"],
    code: "vu",
  },
  {
    country: "Venezuela",
    languages: ["Spanish"],
    code: "ve",
  },
  {
    country: "Vietnam",
    languages: ["Vietnamese"],
    code: "vn",
  },
  {
    country: "Yemen",
    languages: ["Arabic"],
    code: "ye",
  },
  {
    country: "Zambia",
    languages: ["English"],
    code: "zm",
  },
  {
    country: "Zimbabwe",
    languages: ["English"],
    code: "zw",
  },
]
